// extracted by mini-css-extract-plugin
export default {"layout":"home_layout__SKUkF","mainContent":"home_mainContent__moIFZ","asideContent":"home_asideContent__oPMJY"};